import React, { createRef, forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
//import useDetectPrint from 'use-detect-print'

import PrintableTicket from './TranspaisPrintableTicket'

import { TicketType } from '../../utilities/constants'
//import { Impresora } from '../../assets/js/Impresora'

import styles from './TranspaisTicket.module.scss'
import { useAtom } from 'jotai'
import { 
  idleDoneTimerPaused,
  bookingSessionTripConfig
 } from '../../utilities/atoms'
import { useLogger } from '../../contexts/logger.context'
import { currency } from './helpers/currency'
import { PassengerType, TicketService } from './enums'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isSingleTrip } from '../../helpers/tripHelpers'

const TranspaisTicket = forwardRef(({
                              ticket,
                              redondo,
                              regreso,
                              tripData/* = null*/,
                              payment,
                              confirmation,
                              printable/* = null*/,
                              ask,
                              done,
                              onClick
                            }, ref) => {
                              // console.log(ref)
                              // console.log(ask)
  const printableRef = createRef()
  //const isPrinting = false//useDetectPrint()
  const {loggerDebug, loggerError} = useLogger()

  const [, setIdleDonePaused] = useAtom(idleDoneTimerPaused)
  const [printed, setPrinted] = useState(false)
  //const [selected, setSelected] = useState(false)

  const [tripConfig, ] = useAtom(bookingSessionTripConfig)

  const handlePrint = useReactToPrint({
    content: () => {
      loggerDebug('Content', printableRef, printableRef.current)
      return printableRef.current
    }, onBeforePrint: () => {
      setIdleDonePaused(true)
    }, //removeAfterPrint: false,
    onAfterPrint: () => {
      //setIdlePaused(false)
      setIdleDonePaused(false)
      setPrinted(true)
      done()
    }, onPrintError: (errorLocation, error) => {
      loggerError(errorLocation, error)
      setIdleDonePaused(false)
    }
  })

  useImperativeHandle(ref, () => ({
    printTicket() {
      handlePrint()
    }
  }))

  const printTicket = () => {
    //loggerDebug('Printed', printed)
    //setIdlePaused(true)
    if (printed) {
      loggerDebug('Printed', 'ask')
      ask()
    } else {
      setPrinted(true)
      handlePrint()
    }
  }

  //const toggleSelection = () => {
  //setSelected(!selected)
  //}
  useEffect(() => {
    console.log('ticket console log ----------------------------')
    console.log(ticket)
    console.log('r', ref)
  }, [])
// [styles.ticket, !false ? styles.selectable : null, !printable ? ticket.selected ? styles.selected : styles.unselected : null] origin styles conditions
  return (<div ref={ ref }>
    <div
      className={ [styles.ticket].join(' ') }
      onClick={ () => !printable ? onClick(ticket) : null }>
      <div className={ [styles.info, printable ? styles.small : null].join(' ') }>
        <div className={ styles.seat }>
          <h3>Asiento</h3>
          <p>{ ticket.seatSelected }</p>
        </div>
        <div className={ styles.data }>
          <p className={ styles.name }>{ ticket.name }</p>
          { !printable && (<p className={ styles.type }>
            <svg className={ [styles.category, styles.icon].join(' ') }>
              <use xlinkHref={ `#${ TicketType.icon(ticket.fare) }` }/>
            </svg>
            <span>{ TicketType.label(ticket.fare) }</span>
            { !isSingleTrip(tripConfig) && (
              <span className={ [styles.tag, !isSingleTrip(tripConfig) ? styles.return : null].join(' ') }>
                { ticket?.from } › { ticket?.to }
              </span>
            ) }
            {/* { ticket.servicios ? ticket.servicios.map((servicio) => (
              <span key={ `t_${ ticket.id }_${ servicio.id }` } className={ styles.servicio }><FontAwesomeIcon
                icon={ TicketService.icon(servicio.nombre) }
                className={ styles.icon }/> <span>{ servicio.nombre }</span> <span>{ currency(servicio.precio) }</span></span>
            )) : null } */}
          </p>) }
        </div>
      </div>
      { !printable ? (<div className={ styles.precio }>
        <p>{ currency(ticket.displayPassengerTotal ?? 0) }</p>
        { ticket.hasOwnProperty('selected') ?
          <div className={ styles.selectWrapper }>
          <h3>Pagar</h3>
          <svg className={ [styles.icon].join(' ') }>
            <use xlinkHref={ `#${ !ticket.selected ? 'circle-dashed' : 'circle-check' }` }/>
          </svg>
        </div> : null
        }

      </div>) : (<div className={ styles.print } onClick={ printTicket }>
        <svg className={ [styles.icon, printed ? styles.done : null].join(' ') }>
          <use xlinkHref={ `#${ !printed ? 'print' : 'check' }` }/>
        </svg>
        <span>Imprimir</span>
      </div>) }
    </div>
    { printable && (<div style={ {display: 'none'} }><PrintableTicket ref={ printableRef } ticket={ ticket }
                                                                          payment={ payment }
                                                                          confirmation={ confirmation }/>
    </div>) }
  </div>)
})

export default TranspaisTicket
